import { useState, useEffect } from 'react';
import { adminAPI } from '../lib/api';
import { Badge } from '../components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { AdminPageShell, StatCard, EmptyRow } from '../components/AdminShared';

const LN = { en:'English',es:'Spanish',zh:'Mandarin',ar:'Arabic',vi:'Vietnamese',fr:'French',tl:'Tagalog',ko:'Korean',ru:'Russian',pt:'Portuguese',hi:'Hindi' };

export default function AdminSlaPage() {
  const [sla, setSla] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { adminAPI.getSlaCounters().then(r => setSla(r.data)).catch(console.error).finally(() => setLoading(false)); }, []);

  return (
    <AdminPageShell loading={loading} title="SLA Counters" testId="admin-sla-page">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
        <StatCard label="Total Escalations" value={sla?.total_escalations || 0} index={0} />
        <StatCard label="Connected" value={sla?.connected || 0} color="text-[hsl(var(--success))]" index={1} />
        <StatCard label="Breached" value={sla?.breached || 0} color="text-destructive" index={2} />
        <StatCard label="Searching" value={sla?.searching || 0} color="text-[hsl(var(--warning))]" index={3} />
      </div>
      {sla?.by_language && Object.keys(sla.by_language).length > 0 && (
        <div className="rounded-lg border bg-card">
          <div className="p-5 border-b"><h2 className="font-semibold" style={{ fontFamily:'DM Sans' }}>SLA by Language</h2></div>
          <Table>
            <TableHeader><TableRow>
              <TableHead>Language</TableHead><TableHead>Total</TableHead><TableHead>Connected</TableHead><TableHead>Breached</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {Object.entries(sla.by_language).map(([lang, data]) => (
                <TableRow key={lang}>
                  <TableCell><Badge variant="outline" className="text-xs">{LN[lang] || lang}</Badge></TableCell>
                  <TableCell className="font-mono">{data.total}</TableCell>
                  <TableCell className="font-mono text-[hsl(var(--success))]">{data.connected}</TableCell>
                  <TableCell className="font-mono text-destructive">{data.breached}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </AdminPageShell>
  );
}
